module.exports = {
  "language": "1",
  "success": true,
  "data": {
    "headText": {
      "pageOne": {
        "name" : "首页",
        "pageText" : {
          "Product" : "产品展示",
          "series" : {
            "one" : "防晒系列",
            "two" : "防寒系列",
            "three":"泳装系列"
          },
          "introduce" : {
            "patent" : "VVC各国专利品牌。品牌首创以纺织品转化光源，有效将自然光（太阳光）转化为肌肤所需光谱，让人体穿戴相应产品后，能在最舒适凉感状态下体验细胞活化。结合现代人在户外活动和防晒护肤保健的需求，以国际化的设计理念和医学化专业态度，缔造出超强防晒、美肤又保健的时尚户外用品。",
            "brief" : "VVC 品牌简介"
          },
          "story" : {
            "storyText" : "品牌故事",
            "brand" : {
              "idea" : "品牌理念",
              "style" : "产品风格",
              "origin" : "品牌起源"
            }
          }
        }
      } ,
      "pageTwo": {
        "name" :"防晒系列"
      },
      "pageThree": {
        "name" :"瑜伽系列"
      } ,
      "pageFour": {
        "name" :"泳装系列"
      },
      "pageFive":{
        "name" :"视觉系统",
        "pageText" : {
          "visionText":"VVC 视觉系统",
          "column" : "只有在桶里看到的各种各样的视频和造型，以及自然组合选手们的华丽表演的视频和服装。另外，也希望欣赏到桌面上主办的活动和活动。"
        }
      } ,
      "pageSix":{
        "name" : "联名合作",
        "pageText" : {
          "storeText" : "VVC 奥特莱斯",
          "address" : "地址",
          "addressText" : "杭州市武林广场一号杭州大厦商场B座一层127商铺1层 310000, 杭州 Email: store_hangzhou_tower@givenchy.com Tel: +86 571 86 72 27 70"
        }
      } ,
      "pageSeven": {
        "name" :"防伪查询",
        "pageText" : {
          "query" : "授权查询",
          "inputQuery" : "请输入淘宝/天猫 ID",
          "buttonQuery" : "点击查询"
        }
      },
       "pagenine":{
       "return":'返回', 
      "name":'Womens Strap Onepiece Swimsuit Black Flower',
      "span":" Size Small,Medium,Large Material",
      "shop":'必選商品',
      "shops":'商品合计',
      "chima":'选择尺码',
      "yasn":"选择颜色",
      "shuli":"数量",
      "hongs":'红色',
      "bais":'白色',
      "houmai":'立即购买',
      'shoupcar':'加入购物车',  
    },
    "foot":{
      "vvname":'关于VVC',
      'ygkp':'阳光科普',
      'vvcfz':'VVC独特纺织技术',
      'zlbl':'专利布料',
      'ppsm':'品牌使命',
      "crfs":'成人防晒',
      'nxfs':'女性防晒',
      'nvfs':'男性防晒',
      "etfs":"儿童防晒",
      "lmhz":'联名合作',
      'mxlik':'明星联名款',
      'atls':'奥特莱斯',
      'msd':'免税店',
      "fwcx":'防伪查询',
      'dlcx':'代理查询',
      'fcx':'防伪查询',
      'tbtmcx':'天猫授权查询',
      "zxrx":'咨询热线 400-1818-766',
    },
    "classlist":{
        title:"热门商品"
    },
    "entity":{
        "title":"VVC 实体店"
    },
    "viewmore":{
        "title":"查看更多"
    },
    "jojnt":{
        "pingpai":'品牌查询',
        "daili":'代理查询',
        "dangwei":'防伪查询',
        'tianmao':'天猫授权查询',
        "qindail":'请输入代理查询',
        "qindanw":'请输入防伪查询',
        "qintian":'请输入天猫查询',
        "chaxun":'查询',
        "fangwibianm":'请输入产品包装12位防伪码',
        "shouci":'首次查询会显示产品真伪，如果显示产品查询多次非本人操作，请联系官网公众客服。',
        "gongz":"公众号查询 VVC",
        'shouh':'售后服务电话 400-1818-766',
        "searchResult":'查询结果',
        'gengdyi':'更多请在公众号查询',
        "chauxun":'查询号码',
        "chuanxhsi":'查询时间',
    }
    },
   
  }
}



// WEBPACK FOOTER //
// ./src/data/zh.js